<script>

  init.push(function () {
    var $div = $('<div id="signin-demo" class="hidden-xs"><div>PAGE BACKGROUND</div></div>'),
      bgs = ['../assets/images/demo/bg_login.svg', '../assets/demo/signin-bg-2.jpg', '../assets/demo/signin-bg-3.jpg',
        '../assets/demo/signin-bg-4.jpg', '../assets/demo/signin-bg-5.jpg', '../assets/demo/signin-bg-6.jpg',
        '../assets/demo/signin-bg-7.jpg', '../assets/demo/signin-bg-8.jpg', '../assets/demo/signin-bg-9.jpg'];
    for (var i = 0, l = bgs.length; i < l; i++) $div.append($('<img src="' + bgs[i] + '">'));
    $div.find('img').click(function () {
      var img = new Image();
      img.onload = function () {
        $('#page-signin-bg > img').attr('src', img.src);
        $(window).resize();
      }
      img.src = $(this).attr('src');
    });
    $('body').append($div);
  });
</script>

<!-- Page background -->
<div id="page-signin-bg">
  <!-- Background overlay -->
  <div class="overlay"></div>
  <!-- Replace this with your bg image -->
  <img [src]="loginPic" alt="" class="login-logo">
</div>
<!-- / Page background -->
<!-- Container -->
<div class="signin-container">

  <!-- Left side -->
  <div class="signin-info">
    <a class="logo" >
      <img [src]="logo" alt="" >&nbsp;
    </a>

  </div>
  <!-- / Left side -->
  <!-- Right side -->
  <div class="signin-form">

    <div class="form-login-logo">

    </div>
    <!-- Email-OTP verification step -->
    <form *ngIf="mfaStep" class="form-horizontal login" name="mfaForm" #mf="ngForm" novalidate
          (ngSubmit)="mf.form.valid && verifyMfaCode()">
      <div class="signin-text">
        <span>Enter verification code</span>
      </div>
      <div class="row padding-sm-vr">
        <div class="form-group w-icon">
          <input type="text" name="mfa_code" id="mfa_code_id" class="form-control input-lg input-login"
                 placeholder="6-digit code" autocomplete="one-time-code" maxlength="6"
                 [(ngModel)]="mfaCode" #mfaCodeField="ngModel" required>
          <span class="fa fa-shield signin-form-icon"></span>
        </div>
      </div>
      <div class="row padding-sm-vr">
        <div class="checkbox">
          <label>
            <input type="checkbox" name="trust_this_device" [(ngModel)]="trustDeviceChecked"> Trust this device for 30 days
          </label>
        </div>
      </div>
      <div class="form-actions">
        <button type="submit" value="VERIFY" class="signin-btn bg-primary" [disabled]="isLoading">
          <i *ngIf="isLoading" class='fa fa-circle-o-notch fa-spin'></i> <span *ngIf="isLoading">Verifying...</span> <span *ngIf="!isLoading">Verify</span>
        </button>
        <a href="javascript:;" class="forgot-password" (click)="cancelMfaStep()">Back to login</a>
      </div>
    </form>
    <!-- / Email-OTP verification step -->

    <!-- Forced password-change step -->
    <form *ngIf="passwordChangeStep" class="form-horizontal login" name="passwordChangeForm" #pcf="ngForm" novalidate
          (ngSubmit)="pcf.form.valid && completePasswordChange()">
      <div class="signin-text">
        <span>Your password must be changed</span>
      </div>
      <div class="row padding-sm-vr">
        <div class="form-group w-icon">
          <input type="password" name="new_password" id="new_password_id" class="form-control input-lg input-login"
                 placeholder="New password" autocomplete="new-password"
                 [(ngModel)]="newPassword" #newPasswordField="ngModel" required minlength="8">
          <span class="fa fa-lock signin-form-icon"></span>
        </div>
      </div>
      <div class="row padding-sm-vr">
        <div class="form-group w-icon">
          <input type="password" name="confirm_new_password" id="confirm_new_password_id" class="form-control input-lg input-login"
                 placeholder="Confirm new password" autocomplete="new-password"
                 [(ngModel)]="confirmNewPassword" #confirmNewPasswordField="ngModel" required minlength="8">
          <span class="fa fa-lock signin-form-icon"></span>
        </div>
      </div>
      <div class="row padding-sm-vr">
        <password-requirements-checklist #pwReq="passwordRequirementsChecklist"
                                          [password]="newPassword" [confirmPassword]="confirmNewPassword">
        </password-requirements-checklist>
      </div>
      <div class="form-actions">
        <button type="submit" value="CHANGE" class="signin-btn bg-primary" [disabled]="isLoading || !pwReq.allKnownRequirementsMet">
          <i *ngIf="isLoading" class='fa fa-circle-o-notch fa-spin'></i> <span *ngIf="isLoading">Updating...</span> <span *ngIf="!isLoading">Change password</span>
        </button>
        <a href="javascript:;" class="forgot-password" (click)="cancelPasswordChangeStep()">Back to login</a>
      </div>
    </form>
    <!-- / Forced password-change step -->

    <!-- Forgot-password step: request a reset link by email -->
    <form *ngIf="forgotPasswordStep" class="form-horizontal login" name="forgotPasswordForm" #fpf="ngForm" novalidate
          (ngSubmit)="fpf.form.valid && requestPasswordReset()">
      <div class="signin-text">
        <span>Reset your password</span>
      </div>
      <div class="row padding-sm-vr">
        <div class="form-group w-icon">
          <input type="text" name="forgot_password_email" id="forgot_password_email_id" class="form-control input-lg input-login"
                 placeholder="Enter your email" autocomplete="email"
                 [(ngModel)]="forgotPasswordEmail" #forgotPasswordEmailField="ngModel" required>
          <span class="fa fa-envelope signin-form-icon"></span>
        </div>
      </div>
      <div class="form-actions">
        <button type="submit" value="SEND" class="signin-btn bg-primary" [disabled]="isLoading">
          <i *ngIf="isLoading" class='fa fa-circle-o-notch fa-spin'></i> <span *ngIf="isLoading">Sending...</span> <span *ngIf="!isLoading">Send reset link</span>
        </button>
        <a href="javascript:;" class="forgot-password" (click)="cancelForgotPasswordStep()">Back to login</a>
      </div>
    </form>
    <!-- / Forgot-password step -->

    <!-- Reset-password step: reached via the emailed link, sets a new password with the token -->
    <form *ngIf="resetPasswordStep" class="form-horizontal login" name="resetPasswordForm" #rpf="ngForm" novalidate
          (ngSubmit)="rpf.form.valid && completePasswordReset()">
      <div class="signin-text">
        <span>{{resetPasswordSetup ? 'Create your password' : 'Choose a new password'}}</span>
      </div>
      <div class="row padding-sm-vr">
        <div class="form-group w-icon">
          <input type="password" name="reset_new_password" id="reset_new_password_id" class="form-control input-lg input-login"
                 placeholder="New password" autocomplete="new-password"
                 [(ngModel)]="resetNewPassword" #resetNewPasswordField="ngModel" required minlength="8">
          <span class="fa fa-lock signin-form-icon"></span>
        </div>
      </div>
      <div class="row padding-sm-vr">
        <div class="form-group w-icon">
          <input type="password" name="reset_confirm_new_password" id="reset_confirm_new_password_id" class="form-control input-lg input-login"
                 placeholder="Confirm new password" autocomplete="new-password"
                 [(ngModel)]="resetConfirmNewPassword" #resetConfirmNewPasswordField="ngModel" required minlength="8">
          <span class="fa fa-lock signin-form-icon"></span>
        </div>
      </div>
      <div class="row padding-sm-vr">
        <password-requirements-checklist #resetPwReq="passwordRequirementsChecklist"
                                          [password]="resetNewPassword" [confirmPassword]="resetConfirmNewPassword">
        </password-requirements-checklist>
      </div>
      <div class="form-actions">
        <button type="submit" value="RESET" class="signin-btn bg-primary" [disabled]="isLoading || !resetPwReq.allKnownRequirementsMet">
          <i *ngIf="isLoading" class='fa fa-circle-o-notch fa-spin'></i> <span *ngIf="isLoading">Updating...</span> <span *ngIf="!isLoading">{{resetPasswordSetup ? 'Create password' : 'Set new password'}}</span>
        </button>
        <a href="javascript:;" class="forgot-password" (click)="cancelResetPasswordStep()">Back to login</a>
      </div>
    </form>
    <!-- / Reset-password step -->

    <!-- Form -->
    <form *ngIf="formResetToggle && !mfaStep && !passwordChangeStep && !forgotPasswordStep && !resetPasswordStep" class="form-horizontal login" name="loginForm" #f="ngForm" novalidate
          (ngSubmit)="f.form.valid ? login() :
                          (!email.valid && showErrorAlert('Email is required', 'Please enter a valid email'));
                          (!password.valid && showErrorAlert('Password is required', 'Please enter a valid password'))">
      <div class="signin-text">
        <span>

          {{'SigninYourAccount' | translate}}
        </span>
      </div> <!-- / .signin-text -->
      <div class="row">
        <div class="form-group w-icon" [ngClass]="{'has-success': f.submitted && email.valid, 'has-error' : f.submitted && !email.valid}">
          <input type="text" name="signin_username"
                 id="username_id" class="form-control input-lg input-login"
                 placeholder="{{'app.loginName' | translate}}"
                 [(ngModel)]="userLogin.email" #email="ngModel" required>
          <span class="fa fa-user signin-form-icon"></span>

        </div> <!-- / Username -->
        <span *ngIf="f.submitted" class="glyphicon form-control-feedback" [ngClass]="{'glyphicon-ok ': email.valid, 'glyphicon-remove' : !email.valid}" aria-hidden="true"></span>
        <span class="errorMessage" *ngIf="f.submitted && !email.valid">
          {{'validations.loginNameRequired' | translate}}
        </span>
      </div>
      <div class="row padding-sm-vr" style="margin-top: 5%;">
        <div class="form-group w-icon" [ngClass]="{'has-success': f.submitted && password.valid, 'has-error' : f.submitted && !password.valid}">
          <input type="password" name="signin_password"
                 id="password_id" class="form-control input-lg input-login"
                 placeholder="{{'Password' | translate}}"
                 [(ngModel)]="userLogin.password" #password="ngModel" required>
          <span class="fa fa-lock signin-form-icon"></span>


        </div> <!-- / Password -->
        <span *ngIf="f.submitted" class="glyphicon form-control-feedback" [ngClass]="{'glyphicon-ok ': password.valid, 'glyphicon-remove' : !password.valid}" aria-hidden="true"></span>
        <span class="errorMessage" *ngIf="f.submitted && !password.valid">
          {{'validations.passwordRequired' | translate}}
        </span>
      </div>
      <div class="form-group" style="margin-top: 5%;">

        <div class="checkbox">
          <label><input class="input-remember-me" type="checkbox" name="rememberMe" [(ngModel)]="userLogin.rememberMe">{{'app.rememberMe' | translate}}  </label>
        </div>

      </div>
      <div class="form-actions">
        <button type="submit" value="SIGN IN" class="signin-btn bg-primary" [disabled]="isLoading">
          <i *ngIf="isLoading" class='fa fa-circle-o-notch fa-spin'></i> <span *ngIf="isLoading">{{ 'Logging' |translate }}</span> <span *ngIf="!isLoading">{{'app.login' | translate}}</span>
        </button>
        <a href="javascript:;" class="forgot-password" (click)="showForgotPasswordStep()">Forgot your password?</a>
      </div> <!-- / .form-actions -->
    </form>
    <!-- / Form -->
  </div>
  <!-- Right side -->
</div>
<!-- / Container -->


<script type="text/javascript">
  // Resize BG
  init.push(function () {
    var $ph = $('#page-signin-bg'),
      $img = $ph.find('> img');

    $(window).on('resize', function () {
      $img.attr('style', '');
      if ($img.height() < $ph.height()) {
        $img.css({
          height: '100%',
          width: 'auto'
        });
      }
    });
  });

  window.PixelAdmin.start(init);
</script>

